module.exports = __webpack_public_path__ + "static/media/BG.bac76dbd.svg";